import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { normalizeTabSlotLayout } from './normalize-tab-slot-layout.js'

export function normalizeFields(fields: SchemaField[], inheritedSlot?: 'sidebar'): SchemaField[] {
  return fields.map((field) => {
    const tabs = field.tabs?.map(normalizeTabSlotLayout)
    const normalizedField = tabs ? { ...field, tabs } : { ...field }
    if (inheritedSlot) return { ...normalizedField, slot: inheritedSlot }
    return normalizedField
  })
}
